import React, { useMemo } from "react";
import Chart from "react-apexcharts";

import { IZIN_MAP } from "../constants/izinMap";
import { KPI_COLORS } from "../constants/kpiColors";
import { IZIN_ORDER } from "../constants/izinOrder";

// const IZIN_ORDER = Object.keys(IZIN_MAP);

const KEY_ALIAS = {
    CBIB_Kapal: "KAPAL",
};

function normalizeKey(key) {
    return KEY_ALIAS[key] || key;
}

function convertPivotToApex(dataPivot) {
    if (!dataPivot || dataPivot.length === 0) {
        return { categories: [], series: [] };
    }

    const categories = dataPivot.map(item => item.propinsi);

    const normalizedData = dataPivot.map(item => {
        const obj = {};
        Object.entries(item).forEach(([key, val]) => {
            const normalized = normalizeKey(key);
            obj[normalized] = val;
        });
        return obj;
    });

    const series = IZIN_ORDER
        .filter(izin =>
            normalizedData.some(item => item[izin] !== undefined)
        )
        .map(izin => ({
            name: izin,
            data: normalizedData.map(item => item[izin] ?? 0)
        }));

    return { categories, series };
}



const PrimerChart = ({ rekapPrimer }) => {
    const { categories, series } = useMemo(
        () => convertPivotToApex(rekapPrimer),
        [rekapPrimer]
    );

    const seriesColors = useMemo(
        () => series.map(s => KPI_COLORS[s.name]?.iconBg || "#999"),
        [series]
    );

    const chartOptions = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: false },
            fontFamily: '"Inter", sans-serif',
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "60%",
            },
        },
        xaxis: {
            categories,
        },
        dataLabels: { enabled: false },
        tooltip: { enabled: true },
        colors: seriesColors,
    };

    return (
        <Chart
            options={chartOptions}
            series={series}
            type="bar"
            height={rekapPrimer?.length * 30 || 200}
        />
    );
};

export default PrimerChart;
